import { create } from "zustand";
import { useFetchCustomerDetailingReportSlice } from "../slices/CustomerDetailingReportSlices/fetchCustomerDetailingReportSlice";
interface CustomerDetailingReportInterface
  extends ReturnType<typeof useFetchCustomerDetailingReportSlice> {}

export const CustomerDetailingReportStore =
  create<CustomerDetailingReportInterface>((...a) => ({
    ...useFetchCustomerDetailingReportSlice(...a),
  }));
